<template>
  <div>
    <v-text-field
      class="mt-4 mb-2"
      filled
      dense
      rounded
      v-model="table.search"
      append-icon="mdi-magnify"
      label="Filtrer les résultats (un nom, un prénom, une société)"
      single-line
      hide-details
    ></v-text-field>

    <v-data-table
      :headers="table.headers"
      :items="table.rows"
      :options.sync="table.options"
      :server-items-length="table.totalRows"
      :loading="$api.loading('users')"
      :footer-props="{ 'items-per-page-options': [200] }"
      @update:page="refreshTableFromApi"
      @update:sort-by="refreshTableFromApi"
      @update:options="refreshTableFromApi"
    >
      <template v-slot:item.name="{ item }">
        <div v-if="item.role === 'ADMINISTRATOR'" class="blue--text text--darken-2 font-weight-bold">
          <v-icon small color="primary">mdi-police-badge</v-icon> Administrateur
        </div>
        <v-icon small>mdi-account</v-icon> {{ $helpers.present.truncated(item.first_name + ' ' + item.last_name, 25) }}
        <div v-if="item.company" class="font-italic">
          <v-icon small>mdi-domain</v-icon>
          {{ $helpers.present.truncated(item.company, 25) }}
        </div>
      </template>
      <template v-slot:item.contact="{ item }">
        <div><v-icon small>mdi-email</v-icon> {{ $helpers.present.truncated(item.email, 35) }}</div>
        <div><v-icon small>mdi-phone</v-icon> {{ item.phone }}</div>
      </template>
      <template v-slot:item.meta.last_ip_address="{ item }">
        {{ item.meta.last_ip_address }}
      </template>
      <template v-slot:item.subscriptions="{ item }">
        <a
          v-if="getSubscription(item)"
          :href="'https://dashboard.stripe.com/subscriptions/' + getSubscription(item).stripe_id"
          target="_blank"
          class="green--text"
          style="text-decoration: none"
        >
          Oui
          <v-icon small color="green">mdi-open-in-new</v-icon>
        </a>
        <span v-else>-</span>
      </template>
      <template v-slot:item.usage.monitors="{ item }">
        <span :class="getUsageTextClassColor(item.usage.monitors, item.rules['check-position'].max_monitor)">
          {{ item.usage.monitors }} / {{ item.rules['check-position'].max_monitor }}
        </span>
      </template>
      <template v-slot:item.usage.url_monitors="{ item }">
        <span :class="getUsageTextClassColor(item.usage.url_monitors, 200)">
          {{ item.usage.url_monitors }} / 200
        </span>
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ $moment(item.created_at).format('DD/MM/YYYY') }}
      </template>
      <template v-slot:item.meta.last_request_at="{ item }">
        <span v-if="item.meta.last_request_at">{{ $moment(item.meta.last_request_at).format('DD/MM/YYYY à HH:mm') }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn small icon color="primary" @click="$router.push('/admin/users/' + item.id)">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn small icon color="primary" @click="impersonate(item)"
               :loading="table.buttonLoading.id === item.id && table.buttonLoading.type === 'details'">
          <v-icon>mdi-incognito</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'UsersTable',
  data () {
    return {
      table: {
        search: '',
        options: {
          sortBy: ['meta.last_request_at'],
          sortDesc: [true],
        },
        headers: [
          { text: 'Nom', value: 'name', sortable: false },
          { text: 'Contact', value: 'contact', sortable: false },
          { text: 'Adresse IP', value: 'meta.last_ip_address' },
          { text: 'Souscrit', value: 'subscriptions' },
          { text: 'Checks Kw', value: 'usage.checks' },
          { text: 'Suivis Kw', value: 'usage.monitors' },
          { text: 'Suivis Index', value: 'usage.url_monitors' },
          { text: 'Inscrit le', value: 'created_at' },
          { text: 'Actif le', value: 'meta.last_request_at' },
          { text: '', value: 'actions' },
        ],
        totalRows: 0,
        rows: [],
        buttonLoading: {
          id: null,
          type: null
        },
      }
    }
  },
  watch: {
    'table.search': debounce(function () {
      this.refreshTableFromApi()
    }, 500),
    'table.options': {
      handler () {
        this.refreshTableFromApi(true)
      },
      deep: true,
    }
  },
  methods: {
    async refreshTableFromApi () {
      await this.$api.get('users', {
        with_usage: true,
        with_subscriptions: true,
        datatable: true,
        page: this.table.options.page,
        items_per_page: this.table.options.itemsPerPage,
        sort_by: this.table.options.sortBy,
        sort_desc: this.table.options.sortDesc,
        search: this.table.search
      }, { showLoading: false }).then(response => {
        this.table.rows = response.data
        this.table.totalRows = response.meta.total
      })
    },
    getSubscription (item) {
      return item.subscriptions.find(subscription => {
        return subscription.name === 'check-position' && subscription.stripe_status === 'active'
      })
    },
    getUsageTextClassColor (usage, maximum) {
      const remaining = parseInt(usage) / parseInt(maximum) * 100
      if (remaining <= 0) {
        return 'grey--text'
      } else if (remaining < 80) {
        return 'green--text'
      } else if (remaining < 95) {
        return 'orange--text'
      } else {
        return 'red--text font-weight-bold'
      }
    },
    impersonate (user) {
      this.table.buttonLoading.id = user.id
      this.table.buttonLoading.type = 'impersonate'
      this.$account.impersonate(user)
        .then(user => {
          this.$ui.success('Connecté en tant que ' + user.first_name + ' ' + user.last_name + ' avec succès. Déconnectez-vous pour revenir à votre compte administrateur.')
          this.$router.push('/')
        })
        .catch(error => { this.$ui.error('Impossibler de changer de compte : ' + error) })
        .finally(() => {
          this.table.buttonLoading.id = null
          this.table.buttonLoading.type = null
        })
    },
  }
}
</script>